import { useEffect } from 'react';
import { useNikkeCatalog } from '../../nikke-catalog/hooks/useNikkeCatalog.js';
import { setPracticeMatcherCatalog } from '../domain/raidPracticeMatcher.js';

export function useRaidPracticeRecommendationCatalog({ enabled = true } = {}) {
  const { catalog, loading, error } = useNikkeCatalog({ enabled });

  useEffect(() => {
    if (enabled && catalog) setPracticeMatcherCatalog(catalog);
  }, [catalog, enabled]);

  if (!enabled) {
    return {
      catalog: null,
      loading: false,
      errorMessage: '',
    };
  }

  return {
    catalog,
    loading,
    errorMessage: error,
  };
}
